'use strict';

import React from 'react';
import Button from 'components/clarity-ui/inputs/button';
import Checkbox from 'components/clarity-ui/inputs/checkbox';
import CheckboxGroup from 'components/clarity-ui/inputs/checkboxGroup';
import InputField from 'components/clarity-ui/inputs/inputField/inputField';
import ComponentLoader from 'components/clarity-ui/components/componentLoader';
import SectionHeader from 'components/clarity-ui/components/sectionHeader';

class HitEvaluator extends React.Component {

  hasErrors (mturkEvaluator) {
    return mturkEvaluator.title === '' || mturkEvaluator.description === '' || mturkEvaluator.question === '';
  }

  getErrorMsg (item) {
    return item === '' ? 'The Field Value can\'t be empty' : null;
  }

  getSaveButtonAdditionalProps (hasErrors) {
    let additionalProps = {};
    if (!!hasErrors) additionalProps = {disabled: true};

    return additionalProps;
  }

  renderHitEvaluatorForm (otherProps) {
    const { mturkHitEvaluator, title, enabled, handleHitEvaluatorInputOnChange,
      handleSaveHitEvaluatorOnClick } = otherProps;
    const hitEnabled = !!mturkHitEvaluator.targetLabel ? mturkHitEvaluator.targetLabel.targetClassifier.hitEnabled : enabled;
    return (
      <div>
        <SectionHeader>
          { title }
        </SectionHeader>
        <div className="BreakLine">
          <InputField
            id="title"
            label="Hit Title"
            value={mturkHitEvaluator.title}
            onChange={handleHitEvaluatorInputOnChange}
            errorMsg={this.getErrorMsg(mturkHitEvaluator.title)}/>
        </div>
        <div className="BreakLine">
          <InputField
            id="description"
            label="Hit Description"
            value={mturkHitEvaluator.description}
            onChange={handleHitEvaluatorInputOnChange}
            errorMsg={this.getErrorMsg(mturkHitEvaluator.description)}/>
        </div>
        <div className="BreakLine">
          <InputField
            id="question"
            rows="3"
            isTextArea
            label="Question"
            value={mturkHitEvaluator.question}
            onChange={handleHitEvaluatorInputOnChange}
            errorMsg={this.getErrorMsg(mturkHitEvaluator.question)}/>
        </div>
        <div className="BreakLine">
          <CheckboxGroup>
            <Checkbox
              id="hitEnabled"
              checked={hitEnabled}
              value={hitEnabled}
              onChange={handleHitEvaluatorInputOnChange}>
              Enabled
            </Checkbox>
          </CheckboxGroup>
        </div>
        <div className="BreakLine floatRightAlign">
          <Button
            {...this.getSaveButtonAdditionalProps(this.hasErrors(mturkHitEvaluator))}
            elementType="button"
            onClick={handleSaveHitEvaluatorOnClick}>
            Save
          </Button>
        </div>
      </div>
    );
  }

  render () {
    const { loading, ...otherProps } = this.props;
    return (
      <ComponentLoader loading={loading}>
        { loading ? null : this.renderHitEvaluatorForm(otherProps)}
      </ComponentLoader>

    );
  }
}

export default HitEvaluator;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/mturk/hitEvaluator.component.jsx